import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import {
  LegalAgreementAcceptancePayload,
  LegalReacceptanceContent,
  WalletBankAccountPayload
} from './legalReacceptance.model';

const legalReacceptanceApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getLegalReacceptanceContent: builder.query<LegalReacceptanceContent, void>({
      query: () => ({
        url: `${API_VERSION.V1}/legal-agreements/reacceptance-terms`,
        method: 'GET'
      })
    }),
    confirmLegalReacceptance: builder.mutation<void, { teamId: number; payload: LegalAgreementAcceptancePayload }>({
      query: ({ teamId, payload }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/legal-agreement-acceptance`,
        method: 'POST',
        body: payload
      })
    }),
    confirmLegalReacceptanceV2: builder.mutation<void, { teamId: number; payload: LegalAgreementAcceptancePayload }>({
      query: ({ teamId, payload }) => ({
        url: `${API_VERSION.V2}/teams/${teamId}/legal-agreement-acceptance`,
        method: 'POST',
        body: payload
      }),
      extraOptions: {
        failure: 'Something went wrong, please try again',
        showToast: true
      }
    }),
    submitWalletBankAccount: builder.mutation<void, { teamId: number; payload: WalletBankAccountPayload }>({
      query: ({ teamId, payload }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/wallets/submit-bank-account`,
        method: 'POST',
        body: payload
      }),
      extraOptions: {
        failure: 'Something went wrong, please try again',
        showToast: false
      }
    })
  })
});

export const {
  useLazyGetLegalReacceptanceContentQuery,
  useConfirmLegalReacceptanceMutation,
  useConfirmLegalReacceptanceV2Mutation,
  useSubmitWalletBankAccountMutation
} = legalReacceptanceApi;
